import {
    initStripe as loadStripe
} from '@wc-stripe/blocks-utils';
import {Elements} from '@stripe/react-stripe-js';
import CardPaymentElement from './card-payment-element';
import LegacyCardElement from "./legacy-card-element";
import {useElementOptions} from "../hooks";

export const CreditCardComponent = (props) => {
    const {data, billing, shouldSavePayment} = props;
    const {cartTotal, currency} = billing;
    let options = useElementOptions({
        gatewayId: data.gatewayId,
        cartTotal,
        currency,
        elementOptions: data.elementOptions,
        shouldSavePayment
    });
    if (data.isPaymentElement) {
        if (data.installmentsActive && data.clientSecret) {
            options = {clientSecret: data.clientSecret, locale: data.elementOptions.locale}
        }
        return (
            <Elements stripe={loadStripe} options={options}>
                <CardPaymentElement {...props}/>
            </Elements>
        )
    }
    return (
        <Elements stripe={loadStripe} options={options}>
            <LegacyCardElement {...props}/>
        </Elements>
    );
};

export default CreditCardComponent;